import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Enter the RP's ID below to get to the configurations page.")
], -1)
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "input-group mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "input-group-text",
    id: "b3"
  }, "Restaurant ID")
], -1)
const _hoisted_6 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.restaurantId) = $event)),
          class: "form-control",
          "aria-describedby": "b3",
          placeholder: "e.g. 1234"
        }, null, 512), [
          [_vModelText, _ctx.restaurantId]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "btn btn-success ml-1",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goto && _ctx.goto(...args)))
      }, " Go to configurations ")
    ])
  ]))
}